var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.519 17.653L16.172 12l-5.653-5.653 1.414-1.414L19 12l-7.067 7.067-1.414-1.414zm-5.47 0L10.704 12 5.05 6.347l1.414-1.414L13.531 12l-7.067 7.067-1.414-1.414z",
    fill: "#121314"
  })));
}
export default SvgLarge;